import { isAfter, startOfDay } from 'date-fns';
import * as timeModel from "../time";
/** Returns true if the relationship's effectiveDate is in the future. Meaning it's not in-effect yet. */
export function isFutureRelationship(_ref, now) {
  let {
    effectiveDate
  } = _ref;
  return !!effectiveDate && isAfter(effectiveDate instanceof Date ? effectiveDate : timeModel.fromDatestampObject(effectiveDate), startOfDay(now));
}